module.exports = __webpack_public_path__ + "img/buypower.15547084.png";